// Authenticated calls to the ZKTeco admin API (shared by the Attendance Device tabs).
import axios from "axios";

import config from "../../../config";
import { getAuthToken } from "../../../utils/authStorage";

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const zkApi = (method, path, options = {}) =>
  axios({ method, url: `${config.apiBaseUrl}${path}`, headers: authHeaders(), ...options });
